export const confirmpopupTokens = {
  confirmpopup: {
    root: {
      background: '{overlay.popover.background}',
      borderColor: '{overlay.popover.borderColor}',
      color: '{overlay.popover.color}',
      borderRadius: '{borderRadius.md}',
      shadow: '0px 20px 34px 0px rgba(53, 67, 88, 0.08)',
      gutter: '10px'
    }
  }
};

export type ConfirmPopupTokens = typeof confirmpopupTokens;
